import React from 'react';
import Radial1 from '../../../images/icons/Radial1.svg';
import pointer from '../../../images/icons/pointer.svg';

/**
 * Radial Chart Component - Shows a semi-circular gauge with pointer
 * Ported from Flutter RadialChart widget
 */
const RadialChart = ({ value, total }) => {
  // Calculate pointer position based on value (0-100)
  const calculatePointerPosition = (val) => {
    const centerX = 125;
    const centerY = 0;

    // Radius varies based on value to create arc effect
    const radius = val <= 50
      ? 70 + (val / 50) * 10
      : 90 - ((val - 50) / 50) * 40;

    const angleOfPointer = Math.PI - (val / 100) * Math.PI;

    let angle, left, bottom;

    if (val <= 50) {
      const angleRadians = -1 + (val / 50) * 1.5;
      left = centerX + (radius * Math.cos(angleOfPointer));
      bottom = centerY + (radius * Math.sin(angleOfPointer));
      angle = angleRadians;
    } else {
      const angleRadians = 0.5 + ((val - 50) / 50) * 1.7;
      left = centerX + (radius * Math.cos(angleOfPointer));
      bottom = centerY + (radius * Math.sin(angleOfPointer));
      angle = angleRadians;
    }

    return {
      angle: isNaN(angle) ? -1 : angle,
      left,
      bottom,
      centerX,
      centerY
    };
  };

  const pointerPosition = calculatePointerPosition(value);

  return (
    <div className="flex justify-center">
      <div className="relative" style={{ width: '290px', height: 'auto' }}>
        {/* Background Radial Chart */}
        <img src={Radial1} alt="Radial Chart" style={{ width: '290px' }} />

        {/* Pointer */}
        <div
          className="absolute"
          style={{
            bottom: `${pointerPosition.bottom}px`,
            left: `${pointerPosition.left}px`,
            transform: `rotate(${pointerPosition.angle}rad)`,
            transformOrigin: 'center',
          }}
        >
          <img src={pointer} alt="Pointer" />
        </div>

        {/* Center Text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center pt-16">
          <span className="text-3xl font-semibold text-p300">
            {total}
          </span>
          <span className="text-[12px]  text-n700">
            Total
          </span>
        </div>
      </div>
    </div>
  );
};

export default RadialChart;
